import { Typography, Button, Row, Col, Skeleton, Card } from "antd";
import { useDispatch, useSelector } from "react-redux";

import SpaceList from "./components/spaceList";
import { useContext, useState, useEffect } from "react";
import { SpaceContext } from "../../context";
import Notifications from "./components/notifications";
import { getUserSpaces } from "../../services/SpaceServices";
import { setUserSpaces } from "../../redux/slices/userSlice";
import "../../style/space.css"
import { useTranslation } from 'react-i18next';
import ApprovalsPending from "../adminscreens/ApprovalsPending";
import ApprovalsAwaited from "../adminscreens/Approvalsawaited";
import SpaceNewCard from "./components/SpaceNewCard";
import { useTenantNavigation } from "../../hooks/useTenantNavigation.js";
import { getUserDisplayName } from "../../utils/getNameFromEmail";

const { Title } = Typography;

const SpacesPage = () => {
  // const spaces = useContext(SpaceContext);
  const navigate = useTenantNavigation();

  const [spaces, setSpaces] = useState([])
  const [loadingSpaces, setLoadingSpaces] = useState(true);
  const { userInfo, userGroupSpaces } = useSelector(state => state.user)
  const dispatch = useDispatch();
  let userName = getUserDisplayName(userInfo)
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const fetchUserSpaces = async () => {
      if (!userInfo?.email) return;
      setLoadingSpaces(true);
      try {
        const response = await getUserSpaces(userInfo.email);
        if (response.status === 200 && Array.isArray(response.data)) {
          setSpaces(response.data);
          dispatch(setUserSpaces(response.data));
        }
      } finally {
        setLoadingSpaces(false);
      }
    };
    fetchUserSpaces();
  }, [userInfo?.email])

  const navigateToSettings = () => {
    navigate("/app/space/all-spaces");
  };

  return (
    <div className="w-full px-3 py-4 md:px-5 md:py-6 lg:px-10">
      {/* Welcome Section */}
      <div className="mb-8 md:mb-10 lg:mb-12">
        <Title
          level={2}
          className="!m-0 !mb-2 !text-xl sm:!text-2xl lg:!text-3xl !font-semibold"
        >
          {t('Welcome back')}, {userName}!
        </Title>
        <Typography.Text className="text-base text-gray-600">
          {t('Manage your workspace and track approvals')}
        </Typography.Text>
      </div>

      {/* Recently Viewed Spaces Section */}
      <div className="mb-6">
        <Row
          gutter={[16, 16]}
          align="middle"
          className="mb-6"
        >
          <Col xs={24} sm={12} md={16} lg={18}>
            <Title
              level={4}
              className="!m-0 !text-base sm:!text-lg lg:!text-xl !font-medium"
            >
              {t("Recently Viewed Spaces")}
            </Title>
          </Col>
          {spaces.length >= 4 && (
            <Col xs={24} sm={12} md={8} lg={6}>
              <div className="text-right w-full">
                <Button
                  onClick={navigateToSettings}
                  className="w-full sm:w-auto sm:max-w-[120px] hover:-translate-y-0.5 hover:shadow-lg hover:shadow-blue-200 transition-all duration-300"
                  type="primary"
                >
                  {t('View All')}
                </Button>
              </div>
            </Col>
          )}
        </Row>

        {loadingSpaces ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
            {[1, 2, 3, 4, 5].map((item) => (
              <Card key={item} className="w-full" style={{ minHeight: 180 }}>
                <Skeleton avatar={{ shape: 'square', size: 48 }} active paragraph={{ rows: 2 }} />
              </Card>
            ))}
          </div>
        ) : spaces.length > 0 ? (
          <div className="transition-all duration-300">
            <MySpaceList spaces={spaces.slice(0, 5)} userInfo={userInfo} userGroupSpaces={userGroupSpaces} />
          </div>
        ) : (
          <div className="text-center py-12 px-5 bg-gray-50 rounded-lg border border-dashed border-gray-300 mt-4">
            <Typography.Text type="secondary">
              {t('No spaces found. Create your first space to get started.')}
            </Typography.Text>
          </div>
        )}
      </div>

      {/* Dashboard Widgets */}
      <div className="mb-10 md:mb-12 lg:mb-16">
        <Row gutter={[24, 24]}>
          <Col xs={24} lg={12}>
            <div className="h-full bg-white rounded-lg">
              <ApprovalsPending spaces={spaces} />
            </div>
          </Col>
          <Col xs={24} lg={12}>
            <div className="">
              <Title
                level={5}
                className="text-gray-900 font-semibold m-0 mb-4 text-base sm:text-lg"
                style={{ marginBottom: "16px" }}
              >
                {t("Your Requests")}
              </Title>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 h-[89%]">
              <ApprovalsAwaited spaces={spaces} />
            </div>
          </Col>
        </Row>
      </div>

    </div>
  );
};

export default SpacesPage;


const MySpaceList = ({ spaces, userInfo, userGroupSpaces }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 transition-all duration-300">
      {spaces.map((space) => {
        return (
          <div key={space.spaceId} className="flex flex-col w-full transition-all duration-300">
            <SpaceNewCard
              {...space}
              amISpaceManager={true}
              isFavorite={space.isFavorite || false}
              userInfo={userInfo}
              userGroupSpaces={userGroupSpaces}
            />
          </div>
        );
      })}
    </div>
  );
};
